export default () => ({
    init() {},
    open: false,
    toggle() {
        if (this.open) {
            return this.close();
        }
        this.open = true;
        this.$nextTick(() => {
            this.$refs.focusField && this.$refs.focusField.focus();
        });
    },
    close(focusAfter) {
        if (!this.open) return;
        this.open = false;
        focusAfter && focusAfter.focus();
    },
});
